import type { NavigateOptions } from '@tanstack/react-router';
import { SearchX } from 'lucide-react';
import { useCommiteeSlugNavigate } from '@/utils/router';
import { Button } from './Button';

interface NotFoundStateProps {
  title: string;
  backTo: NavigateOptions['to'];
  backLabel: string;
}

export function NotFoundState(props: NotFoundStateProps) {
  const { title, backTo, backLabel } = props;
  const navigate = useCommiteeSlugNavigate();
  // List routes share their path with the detail (`{-$id}`): drop the id, or navigation stays put.

  return (
    <div className="flex h-full items-center justify-center p-8">
      <div className="flex max-w-md flex-col items-center gap-3 text-center">
        <div className="flex size-12 items-center justify-center rounded-full bg-gray-100">
          <SearchX className="size-6 text-gray-500" />
        </div>
        <h2 className="text-lg font-medium text-gray-900">{title}</h2>
        <p className="text-sm text-gray-500">
          Il a peut-être été supprimé, ou le lien utilisé est erroné.
        </p>
        <Button
          variant="outline"
          onClick={() => navigate({ to: backTo, params: { id: undefined } })}
        >
          {backLabel}
        </Button>
      </div>
    </div>
  );
}
